import { getGrowthFeatureDefaults } from "./growth-feature-defaults-copy";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";

export type GrowthFeatureIntroCopy = {
  eyebrow: string;
  title: string;
  titleLastLine?: string;
  description: string;
};

const DEFAULT_INTRO: GrowthFeatureIntroCopy = getGrowthFeatureDefaults("en").intro;

type GrowthFeatureIntroProps = {
  copy?: GrowthFeatureIntroCopy;
};

export function GrowthFeatureIntro({ copy = DEFAULT_INTRO }: GrowthFeatureIntroProps) {
  const lastLine = copy.titleLastLine;
  const titlePrefix = lastLine && copy.title.endsWith(lastLine)
    ? copy.title.slice(0, -lastLine.length).trimEnd()
    : null;

  return (
    <header
      className="cc-growth-features__intro"
      aria-labelledby="growth-features-heading"
    >
      <CcSanjayaEyebrow as="p">{copy.eyebrow}</CcSanjayaEyebrow>
      <h2 className="cc-growth-features__title" id="growth-features-heading">
        {titlePrefix ? (
          <>
            {titlePrefix}{" "}
            <br className="cc-growth-features__title-break" aria-hidden="true" />
            {lastLine}
          </>
        ) : (
          copy.title
        )}
      </h2>
      <p className="cc-growth-features__description">{copy.description}</p>
    </header>
  );
}
